export class NativePasswordAccounts {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return NativePasswordAccounts.attributeTypeMap;
    }
    constructor() {
    }
}
